import { endOfMonth, parse } from "date-fns";
import { DATEFORMAT } from "src/js/util/dates";
import { FilterDCSConditions } from "./FilterDCSConditions";
import { ComparablesFilterFields } from "../components/Filters/FiltersWithClear";
import {
  ComparablesFilterOptions,
  HMLRComparablesFilterOptions,
  HomeTrackComparablesFilterOptions,
} from "../typings/Comparables";
import { DCSConditionGQL, IComparableSearchArgsGQL } from "react-migration/lib/typings/comparables/Comparables";
import { HMLRTenureShorthand, HMLRTenureShorthandGQL } from "react-migration/lib/typings/comparables/HMLR";
import { HometrackTenureShorthandGQL } from "react-migration/lib/typings/comparables/Hometrack";

export function rangeFilter(min?: number, max?: number) {
  if (!min && !max) {
    return undefined;
  }
  return {
    from: min,
    to: max,
  };
}

// TODO: Need to understand this more
export function buildCompsQuery(
  filters?: ComparablesFilterOptions,
  disabledFields?: Set<ComparablesFilterFields>
): IComparableSearchArgsGQL {
  if (!filters) {
    return {};
  }

  const exclude = (filter: ComparablesFilterFields): boolean => disabledFields?.has(filter) ?? false;

  return {
    sold_date_range:
      exclude("dateFrom") && exclude("dateTo")
        ? undefined
        : {
            from: exclude("dateFrom") ? undefined : parse(`01/${filters.dateFrom}`, DATEFORMAT, new Date()),
            to: exclude("dateTo") ? undefined : endOfMonth(parse(`01/${filters.dateTo}`, DATEFORMAT, new Date())),
          },
    bedrooms: exclude("bedrooms")
      ? undefined
      : rangeFilter(
          (filters as HomeTrackComparablesFilterOptions).bedrooms?.min,
          (filters as HomeTrackComparablesFilterOptions).bedrooms?.max
        ),
    total_floor_area_range: exclude("floorArea")
      ? undefined
      : rangeFilter(filters.floorArea?.min, filters.floorArea?.max),
    tenure: (() => {
      if (exclude("tenure") || !filters.tenure) {
        return undefined;
      }
      if (Array.isArray(filters.tenure)) {
        // Trust me bro (remove with hometrackv2)
        if (filters.tenure.length === 1 && (filters.tenure[0] as any) === "Any") {
          return ["F", "L"];
        }
        return filters.tenure as (HMLRTenureShorthandGQL | HometrackTenureShorthandGQL)[];
      }
      if (filters.tenure === "Any") {
        return ["F", "L"];
      }
      return [filters.tenure as HMLRTenureShorthandGQL | HometrackTenureShorthandGQL];
    })(),
    // there's currently no option in the UI to exclude new  builds. It's new builds only OR everything
    is_new_property:
      exclude("newBuildsOnly") || !(filters as HMLRComparablesFilterOptions).newBuildsOnly ? undefined : true,
    dcs_conditions: exclude("dcsConditions")
      ? undefined
      : FilterDCSConditions(filters.dcsConditions, disabledFields)?.map(
          ({ designation, category, sub_category }) =>
            ({
              designation,
              category,
              sub_category,
            } as DCSConditionGQL)
        ),
    year_built:
      (exclude("yearBuiltFrom") && exclude("yearBuiltTo")) ||
      (!(filters as HomeTrackComparablesFilterOptions).yearBuiltFrom &&
        !(filters as HomeTrackComparablesFilterOptions).yearBuiltTo)
        ? undefined
        : {
            from:
              exclude("yearBuiltFrom") || !(filters as HomeTrackComparablesFilterOptions).yearBuiltFrom
                ? undefined
                : (filters as HomeTrackComparablesFilterOptions).yearBuiltFrom,
            to:
              exclude("yearBuiltTo") || !(filters as HomeTrackComparablesFilterOptions).yearBuiltTo
                ? undefined
                : (filters as HomeTrackComparablesFilterOptions).yearBuiltTo,
          },
  };
}
